import fetchData from './fetchData'
import { parseJSON, checkHttpStatus } from '../shared/utils'
import config from '../config/index'

async function roleGetCount(params, payload) {
  const { search } = params

  return fetchData(
    `${config.api.baseUrl}?class=role&action=getcount&search=${search || ''}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function roleGetPage(params, payload) {
  const {
    current, pageSize, search, sort, order,
  } = params

  return fetchData(
    `${config.api.baseUrl}?class=role&action=getpage&current=${current}&pageSize=${pageSize}&sort=${sort}&order=${order}&search=${search || ''}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function roleCreate(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=role&action=create`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function roleRead(values, payload) {
  const { id } = values

  return fetchData(
    `${config.api.baseUrl}?class=role&action=read&id=${id}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function roleUpdate(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=role&action=update`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function roleDelete(values, payload) {
  const { id } = values

  return fetchData(
    `${config.api.baseUrl}?class=role&action=delete&id=${id}`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function roleGetButtonMenu(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=role&action=getButtonMenu`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function roleUpdateButtonMenu(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=role&action=updateButtonMenu`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

export {
  roleGetCount,
  roleGetPage,
  roleCreate,
  roleRead,
  roleUpdate,
  roleDelete,
  roleGetButtonMenu,
  roleUpdateButtonMenu,
}



// WEBPACK FOOTER //
// src/api/role.js